export default __webpack_public_path__ + "static/img_case_03-39cd340a53c541698ff9d9fa1e0032b6.webp";